const colors = {
  transparent: 'transparent',
  mainColor: 'rgb(255,255,255)',
  mainColorDark: 'rgb(60, 173, 233)',
  white: 'rgb(255,255,255)',
  orange: 'rgb(242, 120, 0)',
  lightBlack: 'rgb(27,16,4)',
  black: 'rgb(19,19,19)',
  gray: 'rgb(186,186,186)',
  gray2: 'rgb(136,136,136)',
  lightGray: 'rgb(230,230,230)',
  lightGray2: 'rgb(239, 239, 239)',
  darkGray: 'rgb(51,51,51)',
  mediumDarkGray: 'rgb(233,213,214)',
  darkerGray: 'rgb(76,76,76)',
  darkestGray: 'rgb(34,34,34)',
  moreDarkestGray: 'rgb(21,21,21)',
  grayMenu: 'rgb(153,153,153)',
  lighterGray: 'rgb(112,112,112)',
  lightPink: 'rgb(252, 151, 150)',
  lightBlue: 'rgb(166,221,242)',
  lightBlue2: 'rgb(41,171,239)',
  darkBlue: '#094e7f',
  lightYellow: 'rgb(251, 220, 149)',
  yellow: 'rgb(250,189,0)',
  red: 'rgb(218,9,12)',
  lightOrange: 'rgb(245,135,51)',
  darkRed: 'rgb(165,6,10)',
  whiteRed: 'rgb(237,77,79)',
  green: 'rgb(0,150,64)',
  blackBrown: 'rgb(27, 16, 4)',
  blue: 'rgb(13, 49 ,174)',
  linkColor: 'rgb(99,188,237)',
  mainFontColor: 'rgb(255,255,255)',
  dropDownLiveHub: 'rgb(60, 173, 233)',
  selectedColor: 'rgb(60, 173, 233)',
  liveColor: 'rgb(60, 173, 233)',
  buttonColor: 'rgb(60, 173, 233)',
  worldCupColor: 'rgb(60, 173, 233)',
  colorShadow: 'rgb(255, 255, 255, 0.41)',

  /* Social Colors */
  TwitterColor: 'rgb(0,172,237)',
  TwitterDarkColor: 'rgb(0,138,190)',
  FacebookColor: 'rgb(50,89,152)',
  FacebookDarkColor: 'rgb(47,71,122)',
  GoogleColor: 'rgb(207,62,44)',
  GoogleDarkColor: 'rgb(166,50,35)',
  FlickrColor: 'rgb(238,238,238)',
  FlickrBlueColor: 'rgb(0,99,220)',
  FlickrPinkColor: 'rgb(255,0,132)',
  FlickrDarkColor: 'rgb(190,190,190)',
  RssColor: 'rgb(245,121,0)',
  RssDarkColor: 'rgb(196,97,0)',
};

export default colors;



// WEBPACK FOOTER //
// ./src/theme/corriere/colors.js